import { StripDiv, LabelDiv } from './style';
import { ToolCancelButton } from 'components/tool/Editor/ButtonDiv/CancelButton/cancelButton';

type Props = {
	icon?: React.ReactNode;
	action?: string;
	children?: React.ReactNode;
	cancelDisabled?: boolean;
	className?: string;
}

export default function ActionStrip(props: Props){
	const { icon, action, children, className, cancelDisabled } = props;
	return (
		<StripDiv className={className}>
			{action && <LabelDiv>
				{icon}
				<label>{action}</label>
			</LabelDiv>}

			{children}
			
			<ToolCancelButton id="action-strip-cancel" className='strip-cancel' disabled={cancelDisabled}/>
		</StripDiv>
	);
}
